<template>
    <form class="col-md-8 mx-auto" @submit.prevent="onSubmit">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('institution.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card row">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('institution.information') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-4">
                            <label :for="'number' + _uid" class="font-weight-bold">{{ $t('institution.id') }}</label>
                            <input type="number"
                                   class="form-control"
                                   :id="'id' + _uid"
                                   :name="'id' + _uid"
                                   v-model="institution.id"
                                   :data-vv-as="$t('institution.id')"
                                   readonly/>
                        </div>
                        <div class="form-group col-4">
                            <label :for="'type' + _uid" class="font-weight-bold">{{ $t('institution.type') }}</label>
                            <dropdown :load-by-parent-sort="true"
                                      :parent-sort="nomenclature.InstitutionType"
                                      v-model="institution.typeId"
                                      :data-vv-as="$t('institution.type')"
                                      :name="'institution.type' + _uid"
                                      :fieldName="$t('institution.type')"></dropdown>
                            <span class="text-danger" v-if="errors.has('institution.type' + _uid)">{{ errors.first('institution.type' + _uid) }}</span>
                        </div>
                        <div class="form-group col-4">
                            <label :for="'level' + _uid" class="font-weight-bold">{{ $t('institution.level') }}</label>
                            <dropdown :load-by-parent-sort="true"
                                      :parent-sort="nomenclature.InstitutionLevel"
                                      v-model="institution.levelId"
                                      :data-vv-as="$t('institution.level')"
                                      :name="'institution.level' + _uid"
                                      :fieldName="$t('institution.level')"></dropdown>
                            <span class="text-danger" v-if="errors.has('institution.level' + _uid)">{{ errors.first('institution.level' + _uid) }}</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group col-4">
                            <label :for="'formalMagistratesCount' + _uid" class="font-weight-bold">
                                {{
                                $t('institution.stateGazette')
                                }}
                            </label>
                            <input type="text"
                                   class="form-control"
                                   :id="'stateGazette' + _uid"
                                   :name="'stateGazette' + _uid"
                                   v-model="institution.stateGazette"
                                   :data-vv-as="$t('institution.stateGazette')"/>
                            <span class="text-danger" v-if="errors.has('stateGazette' + _uid)">{{ errors.first('stateGazette' + _uid) }}</span>
                        </div>
                        <div class="form-group col-8">
                            <label :for="'name' + _uid" class="font-weight-bold required">
                                {{ $t('institution.name') }}
                            </label>
                            <input type="text"
                                   class="form-control"
                                   :id="'name' + _uid"
                                   :name="'name' + _uid"
                                   v-model="institution.name"
                                   v-validate="'required'"
                                   :data-vv-as="$t('institution.name')"/>
                            <span class="text-danger"
                                  v-if="errors.has('name' + _uid)">{{ errors.first('name' + _uid) }}</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group col-4">
                            <label :for="'protocol' + _uid" class="font-weight-bold">
                                {{ $t('institution.protocol')}}
                            </label>
                            <input type="text"
                                   class="form-control"
                                   :id="'protocol' + _uid"
                                   :name="'protocol' + _uid"
                                   v-model="institution.protocol"
                                   :data-vv-as="$t('institution.protocol')"/>
                            <span class="text-danger" v-if="errors.has('protocol' + _uid)">{{ errors.first('protocol' + _uid) }}</span>
                        </div>
                        <div class="form-group col-4">
                            <label :for="'realMagistratesCount' + _uid" class="font-weight-bold">
                                {{
                                $t('institution.realMagistratesCount')
                                }}
                            </label>
                            <input type="number"
                                   class="form-control"
                                   :id="'realMagistratesCount' + _uid"
                                   :name="'realMagistratesCount' + _uid"
                                   v-model="institution.realMagistratesCount"
                                   :data-vv-as="$t('institution.realMagistratesCount')"/>
                            <span class="text-danger" v-if="errors.has('realMagistratesCount' + _uid)">{{ errors.first('realMagistratesCount' + _uid) }}</span>
                        </div>
                        <div class="form-group col-4">
                            <label :for="'realEmployeesCount' + _uid" class="font-weight-bold">
                                {{
                                $t('institution.realEmployeesCount')
                                }}
                            </label>
                            <input type="number"
                                   class="form-control"
                                   :id="'realEmployeesCount' + _uid"
                                   :name="'realEmployeesCount' + _uid"
                                   v-model="institution.realEmployeesCount"
                                   :data-vv-as="$t('institution.realEmployeesCount')"/>
                            <span class="text-danger" v-if="errors.has('realEmployeesCount' + _uid)">{{ errors.first('realEmployeesCount' + _uid) }}</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group col-4">
                            <label :for="'formalMagistratesCount' + _uid" class="font-weight-bold">
                                {{
                                $t('institution.formalMagistratesCount')
                                }}
                            </label>
                            <input type="number"
                                   class="form-control"
                                   :id="'formalMagistratesCount' + _uid"
                                   :name="'formalMagistratesCount' + _uid"
                                   v-model="institution.formalMagistratesCount"
                                   :data-vv-as="$t('institution.formalMagistratesCount')"/>
                            <span class="text-danger" v-if="errors.has('formalMagistratesCount' + _uid)">{{ errors.first('formalMagistratesCount' + _uid) }}</span>
                        </div>
                        <div class="form-group col-4">
                            <label :for="'formalEmployeesCount' + _uid" class="font-weight-bold">
                                {{
                                $t('institution.formalEmployeesCount')
                                }}
                            </label>
                            <input type="number"
                                   class="form-control"
                                   :id="'formalEmployeesCount' + _uid"
                                   :name="'formalEmployeesCount' + _uid"
                                   v-model="institution.formalEmployeesCount"
                                   :data-vv-as="$t('institution.formalEmployeesCount')"/>
                            <span class="text-danger" v-if="errors.has('formalEmployeesCount' + _uid)">{{ errors.first('formalEmployeesCount' + _uid) }}</span>
                        </div>
                        <div class="form-group col-4">
                            <label :for="'totalFormalCount' + _uid" class="font-weight-bold">
                                {{
                                $t('institution.totalFormalCount')
                                }}
                            </label>
                            <input type="number"
                                   class="form-control"
                                   :id="'totalFormalCount' + _uid"
                                   :name="'totalFormalCount' + _uid"
                                   v-model="totalFormalCount"
                                   :data-vv-as="$t('institution.totalFormalCount')"
                                   readonly/>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group col-12">
                            <label class="font-weight-bold" :for="'areaOfApeal' + _uid">
                                {{
                                $t('address.areaOfAppeal')
                                }}
                            </label>
                            <input type="text"
                                   class="form-control "
                                   readonly
                                   v-model="areaOfApeal"
                                   :name="'areaOfApeal' + _uid"
                                   :data-vv-as="$t('address.streetNum')"
                                   :id="'areaOfApeal' + _uid"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card row mt-5">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('institution.mainInfo') }}</div>
                </div>
                <div class="card-body">
                    <company :company="institution.company"
                             :showAreaOfAppeal="true"
                             :checkVatUniqueness="true"
                             :checkCompanyNameUniqueness="true"
                             :vat-number-required="false"
                             :removable-manager="true"
                             :removable-contact="true"
                    />
                </div>
            </div>
            <div class="card row mt-5">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('otherFields.otherFields') }}</div>
                </div>
                <div class="card-body">
                    <otherFields :otherFields="institution.otherFields"></otherFields>
                </div>
            </div>

            <AuxiliaryRegister ref="auxiliaryRegisterRef"
                               :register-id="AuxiliaryRegisters.Institutions_Organizations"
                               register-name="Institution"
                               :entry-id="institution.auxRegisterEntityId"/>

            <div class="text-center mt-2 mb-5">
                <button type="button" class="btn btn-primary btn" @click="onSubmit">
                    <i class="fas fa-save"></i>
                    {{ $t('buttons.save.btnText') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import Dropdown from '@/components/dropdown/NomenclatureDropdown';
    import OtherFields from '@/components/otherFields/OtherFields.vue';
    import Company from '@/components/company/Company.vue'
    import { Institution } from '@/models/models';
    import PageTitle from '@/components/common/PageTitle';
    import { NomenclatureParentBySort, AuxiliaryRegisters } from '@/models/enums';
    import AuxiliaryRegister from '@/components/dynamic/AuxiliaryRegister';

    export default {
        components: {
            Dropdown,
            PageTitle,
            OtherFields,
            Company,
            AuxiliaryRegister
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort,
                id: null,
                institution: new Institution({}, true, true),
                loading: false,
                isSaved: false,
                AuxiliaryRegisters: AuxiliaryRegisters
            }
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.institution.auxRegisterModel = this.$refs.auxiliaryRegisterRef.getDynamicRegisterModelForSubmit();
                        this.checkForExistingVatNumber(this.id, this.institution.company.vatNumber)
                            .then(data => {
                                if (data && data.id) {
                                    this.$vs.notify({
                                        title: this.$t('institution.vatNumberExistsCheck'),
                                        text: this.$t('institution.vatNumberExists', [this.institution.company.vatNumber, data.name, data.id]),
                                        color: 'warning',
                                        time: this.$store.getters.notificationDuration
                                    })
                                } else {
                                    if (this.id) {
                                        this.edit();
                                    } else {
                                        this.create();
                                    }
                                }
                            })
                            .catch(error => {
                            });
                    }
                })
            },
            backToRegister() {
                this.$router.push('/registers/institutions');
            },
            create() {
                this.loading = true;
                this.$http.post('/api/institution', this.institution).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
            edit() {
                this.loading = true;
                this.$http.put('/api/institution', this.institution).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'), // TODO:
                        text: this.$t('notifications.successfulSavedData'), // TODO:
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/institution/${this.id}`).then(response => {
                    this.institution = new Institution(response.data, true, true);
                }).then((result) => {
                        this.$store.initialModel = _.cloneDeep(this.institution);
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            },
            checkForExistingVatNumber(id, vatNumber) {
                return new Promise((resolve, reject) => {
                    this.$http.get('/api/institution/checkForExistingVatNumber', {
                        params: {
                            id: id,
                            vatNumber: vatNumber
                        }
                    })
                        .then(response => {
                            resolve(response.data);
                        }).catch(error => {
                        reject(error);
                    });
                });
            },
            difference(object, base) {
                return _.transform(object, (result, value, key) => {
                    if (!_.isEqual(value, base[key])) {
                        result[key] = _.isObject(value) && _.isObject(base[key]) ? this.difference(value, base[key]) : value;
                    }
                });
            },
            removeEmptyObjects(obj) {
                return _(obj)
                    .pickBy(_.isObject) // pick objects only
                    .mapValues(this.removeEmptyObjects) // call only for object values
                    .omitBy(_.isEmpty) // remove all empty objects
                    .omitBy(_.isNull) // remove all null objects
                    .omitBy(_.isUndefined)// remove all undefined objects
                    .assign(_.omitBy(obj, _.isObject)) // assign back primitive values
                    .value();
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
        },
        beforeRouteLeave(to, from, next) {
            // let currentModel = _.pickBy(this.institution, _.identity);
            let currentModel = this.removeEmptyObjects(this.institution)
            this.$store.currentModel = _.cloneDeep(currentModel);
            let diffs = this.difference(this.$store.initialModel, this.$store.currentModel);
            console.log(diffs);
            if (!_.isEqual(this.$store.initialModel, this.$store.currentModel) && !this.isSaved) {
                const answer = window.confirm(this.$t('notifications.leavePage'))
                if (answer) {
                    next()
                } else {
                    next(false)
                }
            } else {
                next()
            }
        },
        computed: {
            totalFormalCount: function () {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.institution.totalFormalCount = parseInt(this.institution.formalEmployeesCount) + parseInt(this.institution.formalMagistratesCount);
                return this.institution.totalFormalCount;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            areaOfApeal() {
                if (!this.institution.company.registeredAddress.areaOfAppeal) {
                    return '';
                }
                return `${this.isEnVersion ? this.institution.company.registeredAddress.areaOfAppeal.nameEn : this.institution.company.registeredAddress.areaOfAppeal.name} \\ ${this.institution.company.registeredAddress.areaOfAppeal.districtCode}`
            }
        },
        watch: {
            'institution.company.id'(newVal) {
                if (newVal) {
                    this.institution.companyId = this.institution.company.id;
                }
            }
        }
    }
</script>

<style scoped>
</style>
